<template>
  <div class="search-box">
    <span class="material-icons"
          aria-hidden="true"
    >search</span>
    <input :value="modelValue"
           type="search"
           :placeholder="placeholder"
           :aria-label="placeholder"
           @input="onInput"
    >
  </div>
</template>

<script setup>
import { defineProps, defineEmits, onBeforeUnmount } from 'vue'

// Search field used above the task and site lists. Emits the text right away for v-model and
// as "search" once typing pauses, so lists are fetched once per search.
const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  delay: {
    type: Number,
    default: 300
  }
})

const emit = defineEmits(['update:modelValue', 'search'])

let timer = null

function onInput (event) {
  emit('update:modelValue', event.target.value)
  clearTimeout(timer)
  timer = setTimeout(() => emit('search', event.target.value.trim()), props.delay)
}

onBeforeUnmount(() => {
  clearTimeout(timer)
})
</script>

<style lang="scss" scoped>
.search-box {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 1rem;
  padding: 0 0.75rem;
  height: 50px;
  // Wide enough for the placeholder in every language, shrinks on narrow screens
  flex: 0 1 480px;
  min-width: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 25px;

  .material-icons {
    color: var(--mainBlue);
  }

  input {
    flex: 1;
    min-width: 0;
    border: none;
    outline: none;
    font-family: inherit;
    font-size: 0.95rem;
    text-overflow: ellipsis;
  }
}
</style>
